import React from "react"
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  InputAdornment,
  IconButton,
  OutlinedInput,
  Typography,
  Box,
} from "@mui/material"
import { Email, Visibility, VisibilityOff } from "@mui/icons-material"

type InputShowcaseProps = {
    size: "small" | "medium"
    setSize: (size: "small" | "medium") => void
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const InputShowcase: React.FC<InputShowcaseProps> = ({size, setSize}) => {
  const [showPassword, setShowPassword] = React.useState(false)

  const handleClickShowPassword = () => setShowPassword((show) => !show)

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault()
  }

  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      <Typography className="text-xl font-bold">Inputs Showcase</Typography>
      <FormControl size={size} fullWidth>
        <InputLabel htmlFor="demo-select-small">Age</InputLabel>
        <Select id="demo-select-small" label="Age">
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          <MenuItem value={10}>Ten</MenuItem>
          <MenuItem value={20}>Twenty</MenuItem>
          <MenuItem value={30}>Thirty</MenuItem>
        </Select>
      </FormControl>

      <FormControl size={size} fullWidth>
        <InputLabel htmlFor="outlined-adornment-amount">Amount</InputLabel>
        <OutlinedInput
          id="outlined-adornment-amount"
          startAdornment={<InputAdornment position="start">$</InputAdornment>}
          label="Amount"
        />
      </FormControl>

      <FormControl variant="outlined" fullWidth>
        <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
        <OutlinedInput
          label="Password"
          id="outlined-adornment-password"
          type={showPassword ? "text" : "password"}
          value="password"
          size={size}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
              >
                {showPassword ?
                  <Visibility />
                :
                  <VisibilityOff />
                }
              </IconButton>
            </InputAdornment>
          }
        />
      </FormControl>

      <FormControl variant="outlined" fullWidth>
        <InputLabel htmlFor="outlined-adornment-email">Email</InputLabel>
        <OutlinedInput
          id="outlined-adornment-email"
          type="email"
          label="Email"
          size={size}
          startAdornment={
            <InputAdornment position="start">
              <Email />
            </InputAdornment>
          }
        />
      </FormControl>        
    </Box>
  )
}

export default InputShowcase
